import { Injectable } from "@angular/core";
interface Closable {
    close(): void;
}

@Injectable()
export class PaneService {
    private _openPane!: Closable;

    public paneOpened(pane: Closable) {
        if (this._openPane !== pane) {
            if (this._openPane) {
                this._openPane.close();
            }

            this._openPane = pane;
        }
    }
}
